import { useEffect, useRef, useState } from "react";
import { FaShareAlt, FaFacebook, FaWhatsapp, FaLink } from "react-icons/fa";
import { FaLinkedin, FaXTwitter } from "react-icons/fa6";
import "./SharePost.scss";

const SharePost = ({ post }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const shareUrl = `${window.location.origin}/page/${post?.slug}`;
  const encodedUrl = encodeURIComponent(shareUrl);
  const text = encodeURIComponent(post?.title);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const recordShare = async (platform) => {
    try {
      await fetch("/api/shares", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ postId: post?.slug, platform }),
      });
    } catch (err) {
      console.error("Share log failed:", err);
    }
  };

  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(shareUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000); // reset after 2s
  };

  return (
    <div className="share-wrapper" ref={dropdownRef}>
      <button
        className="share-toggle"
        onClick={() => setOpen((prev) => !prev)}
        aria-label="Share this post"
      >
        <FaShareAlt />
        <span>Share</span>
      </button>

      {open && (
        <div className="share-dropdown">
          <a
            href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`}
            onClick={() => recordShare("facebook")}
            target="_blank"
            rel="noopener noreferrer"
            className="share-option facebook"
          >
            <FaFacebook />
            <span>Facebook</span>
          </a>
          <a
            href={`https://twitter.com/intent/tweet?url=${encodedUrl}&text=${text}`}
            onClick={() => recordShare("x")}
            target="_blank"
            rel="noopener noreferrer"
            className="share-option x"
          >
            <FaXTwitter /> {/* You need this new icon */}
            <span>X(Twitter)</span>
          </a>

          <a
            href={`https://wa.me/?text=${text}%20${encodedUrl}`}
            onClick={() => recordShare("whatsapp")}
            target="_blank"
            rel="noopener noreferrer"
            className="share-option whatsapp"
          >
            <FaWhatsapp />
            <span>WhatsApp</span>
          </a>
          <a
            href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`}
            onClick={() => recordShare("linkedin")}
            target="_blank"
            rel="noopener noreferrer"
            className="share-option linkedin"
          >
            <FaLinkedin />
            <span>LinkedIn</span>
          </a>

          {/* <button onClick={handleCopy} className="share-option copy">
            <FaLink />
            <span>Copy Link</span>
          </button> */}
          <button onClick={handleCopy} className="share-option copy">
            <FaLink />
            <span>{copied ? "Link copied!" : "Copy Link"}</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default SharePost;
